import {
	backButton,
	initData,
	init as initSDK,
	miniApp,
	themeParams,
	viewport,
} from "@tma.js/sdk-react"
import { isDevMode } from "./env"

export const initTelegramApp = () => {
	if (isDevMode()) {
		console.log("🔧 Dev mode: Skipping Telegram SDK initialization")
		return
	}

	try {
		initSDK()

		initData.restore()

		if (miniApp.mount.isAvailable()) {
			miniApp.mount()
			miniApp.ready()

			if (miniApp.setHeaderColor.isAvailable()) {
				miniApp.setHeaderColor("bg_color")
			}
			if (miniApp.setBgColor.isAvailable()) {
				miniApp.setBgColor("bg_color")
			}
		}

		if (viewport.mount.isAvailable()) {
			viewport.mount()
			viewport.expand()

			if (viewport.requestFullscreen.isAvailable()) {
				try {
					viewport.requestFullscreen()
				} catch (e) {
					console.warn("Fullscreen request failed:", e)
				}
			}

			if (viewport.bindCssVars.isAvailable()) {
				viewport.bindCssVars()
			}
		}

		if (themeParams.mount.isAvailable()) {
			themeParams.mount()

			if (themeParams.bindCssVars.isAvailable()) {
				themeParams.bindCssVars()
			}
		}

		if (backButton.mount.isAvailable()) {
			backButton.mount()
		}
	} catch (error) {
		console.error("Failed to initialize Telegram SDK:", error)
	}
}
